import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";

const parafolioHosts = ["parafolio.co.uk", "paraportfolio.co.uk"];

Sentry.init(
  {
    dsn: "https://111dd313f90a58cdccc0b870b6f3f65f@o4509247423774720.ingest.de.sentry.io/4509526140059728",
    integrations: [SentryReact.browserTracingIntegration()],
    environment: parafolioHosts.includes(window.location.host) ? "production" : "development",
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
    ],
  },
  // Forward the init method from @sentry/react
  SentryReact.init
);
